import { H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { type Collection } from "../../types"
import { useNavigate } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import { useMemo } from "react"
import { ScrollLayout } from "../../components/ScrollLayout"
import { useCreateCollection } from "../../hooks/collections"
import { initialValuesCollection, validationSchemaCollection } from "./CollectionCommon"
import CollectionForm from "./CollectionForm"

export default function CollectionCreate() {
  const createCollection = useCreateCollection()
  const navigate = useNavigate()

  const initialValues = useMemo(() => initialValuesCollection(), [])
  const validationSchema = useMemo(() => validationSchemaCollection(), [])

  useBreadcrumbs([{ label: "Raccolte", href: "/collections/collections" }, { label: "Creazione Raccolta" }])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <H1>Nuova raccolta</H1>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              return createCollection.mutateAsync(values as Collection).then((collection) => {
                navigate(`/collections/collections/${collection.id}`)
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <CollectionForm />
                </Container>
                <BottomFormFixed url="/collections/collections" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
    </Layout>
  )
}
